import {
  Absence,
  AbsenceFilters,
  AbsenceListResult,
  CreateAbsenceDto,
  UpdateAbsenceDto,
} from "@myapp/contract";
import apiClient from "../../../shared/config/axios";

/**
 * Absences (Abwesenheiten) live at /absences since the ScheduleEntry refactor.
 * The old /time-entries/time-management routes are gone, and breaks moved to
 * /schedule/break — see entities/schedule.
 */
export const absenceApi = {
  // Typed from the contract, not from the local `Paginated<T>`. The two used to be declared
  // independently and silently drifted apart — the API answered `{ items, total, page, limit }`
  // while the client read `lastPage.meta`. Sharing the type makes that a compile error.
  search: (params: AbsenceFilters & { page: number }) =>
    apiClient.get<AbsenceListResult>("/absences", { params }),

  getById: (id: number) => apiClient.get<Absence>(`/absences/${id}`),

  create: (dto: CreateAbsenceDto) => apiClient.post<Absence>("/absences", dto),

  update: (id: number, dto: UpdateAbsenceDto) =>
    apiClient.patch<Absence>(`/absences/${id}`, dto),

  remove: (id: number) => apiClient.delete(`/absences/${id}`),
};
